export default {
  SET_SELECTED_PRODUCT(state, val) {
    if (val) {
      state.selectedProduct = val.product;
      if (val.sizeId) state.selectedProduct.sizeId = val.sizeId;
      else state.selectedProduct.sizeId = null;
    } else state.selectedProduct = val;
  },
  SET_PRE_SELECTED_PRODUCT(state, val) {
    state.preSelectedProduct = val;
  },
  SET_UPDATE_ENTRY(state, val) {
    state.toUpdateEntry = val;
  },
  ADD_TO_CART(state, val) {
    let activeCart = state.carts.find((x) => x !== null && x.active);
    if (!activeCart) return;

    if (val.status === undefined || val.status === null) {
       val.status = 0; // v122: Yeni eklenen ürün 'Baskı Bekliyor' durumundadır.
    }
    activeCart.cartEntries.push(val);
    
    // FIX [v53]: totalPrice'ı sıfırlamak yerine üzerine ekleyerek mevcut (sunucudan gelen) tutarı koru
    activeCart.totalPrice = (activeCart.totalPrice || 0) + val.price;
    activeCart.totalPrice = Math.round(activeCart.totalPrice * 100) / 100;
    
    // Add payment group directly in the mutation
    if (!activeCart.paymentGroups) {
      activeCart.paymentGroups = [];
    }
    let tempPaymentGroup = {
      rowIndex: val.id,
      entries: [val],
      totalPrice: val.price,
      payedPrice: 0,
      status: "Kalan",
      isSend: false,
    };
    activeCart.paymentGroups.push(tempPaymentGroup);
    activeCart.totalPayedPrice = 0;
    activeCart.isFullTable = true;
  },
  SET_TO_CART(state, val) {
    // FIX [v22]: Once o anki aktif sepetin ID'sini yakala
    const activeCart = state.carts.find((x) => x && x.active);
    const currentActiveId = activeCart ? activeCart.id : null;
    if (val && Array.isArray(val)) {
      val.forEach(newCart => {
        // [Kritik] Seans Tutarlılığı: Frontend seans UUID'si konusunda otoritedir.
        // Polling sırasında sunucudan farklı veya boş bir UUID gelse bile, yereldeki UUID'yi KORU ve ÜZERİNE YAZ.
        const currentCart = state.carts.find(c => c && (c.id === newCart.id || c.tableId === newCart.tableId));
        if (currentCart && currentCart.branchTableUId && !newCart.branchTableUId) {
          newCart.branchTableUId = currentCart.branchTableUId;
          console.log(`[UUID Protection v28] Recovered UUID ${currentCart.branchTableUId} for table ${newCart.tableId}`);
        }

        // [v28] RowVersion Koruma: Sunucudan null gelirse hafızadaki son geçerli versiyonu kaybetme
        if (currentCart && currentCart.rowVersion && !newCart.rowVersion) {
          newCart.rowVersion = currentCart.rowVersion;
          console.log(`[RowVersion Protection v28] Protected local RowVersion for table ${newCart.tableId}`);
        }
        
        if (currentCart && currentCart.realId && !newCart.realId) {
          newCart.realId = currentCart.realId;
        }
        
        // Tum gelen sepetleri varsayilan olarak pasif yap
        newCart.active = false;
      });
      state.carts = val;

      // Eger daha once bir sepet aktifse, onu yeni listede bul ve aktifligini geri yukle
      if (currentActiveId) {
        const cartToActivate = state.carts.find(c => c && c.id === currentActiveId);
        if (cartToActivate) {
          cartToActivate.active = true;
        } else if (state.carts.length > 0) {
          state.carts[0].active = true;
        }
      } else if (state.carts.length > 0) {
        state.carts[0].active = true;
      }
    }
  },
  UPDATE_TO_CART(state, obj) {
    if (obj) {
      let activeCart = state.carts.find((x) => x && x.active);
      if (!activeCart) return;

      const oldEntry = activeCart.cartEntries[obj.index];
      const priceDiff = obj.entry.price - (oldEntry ? oldEntry.price : 0);
      
      if (obj.entry.status === undefined || obj.entry.status === null) {
         obj.entry.status = 0; // v122: Güncellenen ürün de tekrar baskıya gidebilir (opsiyonel, genelde not değişimi vb. için istenir)
      }
      activeCart.cartEntries[obj.index] = obj.entry;
      
      // FIX [v53]: Farkı ekleyerek mevcut tutarı koru
      activeCart.totalPrice = (activeCart.totalPrice || 0) + priceDiff;
      activeCart.totalPrice = Math.round(activeCart.totalPrice * 100) / 100;

      // Update payment group directly in the mutation
      if (!activeCart.paymentGroups) {
        activeCart.paymentGroups = [];
      }
      const groupIndex = activeCart.paymentGroups.findIndex(x => x.entries && x.entries.some(y => y.id == obj.entry.id));
      let tempPaymentGroup = {
        rowIndex: obj.entry.id,
        entries: [obj.entry],
        totalPrice: obj.entry.price,
        payedPrice: 0,
        status: "Kalan",
        isSend: false,
      };
      if (groupIndex !== -1) {
        activeCart.paymentGroups.splice(groupIndex, 1, tempPaymentGroup);
      } else {
        activeCart.paymentGroups.push(tempPaymentGroup);
      }
      activeCart.totalPayedPrice = 0;
      activeCart.isFullTable = true;
    }
    state.toUpdateEntry = null;
  },
  SET_AREAS(state, val) {
    state.areas = val;
  },
  ADD_TO_AREAS(state, val) {
    state.areas.push(val);
  },
  SET_CURRENT_TAB(state, tab) {
    state.currentTab = tab;
  },
  REMOVE_ENTRY_FROM_CART(state, val) {
    let activeCart = state.carts.find((x) => x != null && x.active);
    if (!activeCart) return;

    const itemsToRemove = Array.isArray(val) ? val : [val];

    itemsToRemove.forEach(item => {
      const entryId = item.id || (item.entries && item.entries[0] ? item.entries[0].id : null);
      if (entryId) {
        let index = activeCart.cartEntries.findIndex((x) => x.id == entryId);
        if (index !== -1) {
          const removedEntry = activeCart.cartEntries[index];
          // FIX [v53]: Silinen ürünün fiyatını toplamdan düş
          activeCart.totalPrice = (activeCart.totalPrice || 0) - removedEntry.price;
          activeCart.cartEntries.splice(index, 1);
        }

        if (activeCart.paymentGroups) {
          activeCart.paymentGroups = activeCart.paymentGroups.filter(
            (pg) => pg.rowIndex != entryId
          );
        }
      }
    });

    activeCart.totalPrice = Math.round(activeCart.totalPrice * 100) / 100;
  },
  CREATE_NEW_CART(state, val) {
    state.carts.forEach((x) => {
      if (x) {
        x.active = false;
      }
    });
    state.carts.push(val);
  },
  REMOVE_THE_CART(state, val) {
    const cartToRemove = state.carts.find((x) => x.id === val);
    if (cartToRemove) {
      if (state.carts.length === 1) {
        state.carts = [
          {
            id: Date.now(),
            cartEntries: [],
            totalPrice: 0,
            active: true,
          },
        ];
      } else {
        state.carts = state.carts.filter((x) => x.id !== val);
      }
    }
  },
  SET_CURRENT_CART(state, val) {
    state.carts.forEach((x) => {
      if (x != null) {
        if (x.id == val.id) {
          x.active = true;
        } else {
          x.active = false;
        }
      }
    });
  },
  SET_CURRENT_CART_BY_ID(state, val) {
    state.carts.forEach((x) => {
      if (x != null) {
        if (x.id == val) {
          x.active = true;
        } else {
          x.active = false;
        }
      }
    });
  },
  SET_CURRENT_CART_WITH_CAMPAIGN(state, val) {
    let cart = state.carts.find((x) => x.active);
    // eslint-disable-next-line no-undef
    cart.cartEntries = structuredClone(val);
  },
  SET_ACTIVE_PERSONAL(state, val) {
    state.activePersonal = val;
    if (val != null) {
      state.screenLock = false;
    } else {
      state.screenLock = true;
    }
  },
  SET_SCREEN_LOCK(state, val) {
    state.screenLock = val;
  },
  SET_IS_LOADING(state, val) {
    state.isLoading = val;
  },
  SET_PERSON_LIST(state, val) {
    state.personList = val;
  },
  SET_IS_RESET(state, val) {
    state.isReset = val;
  },
  SET_LAST_BILL_ID(state, val) {
    if (!val) {
      state.lastBillId++;
    } else {
      state.lastBillId = val;
    }
  },
  SET_PAYMENT_METHODS(state, val) {
    state.paymentMethods = val;
  },
  SET_SELECTED_PAYMENT_METHOD(state, val) {
    let methods = state.paymentMethods.map((data) => {
      if (data.id == val.id) data.selected = true;
      else data.selected = false;
      return data;
    });
    state.paymentMethods = methods;
    state.selectedPaymentMethod = val;
  },
  SET_ACTIVE_PERSONAL_USER_CODE(state, val) {
    state.activePersonal.userCode = val;
  },
  SET_LOSS_MODE(state, val) {
    state.isLossModeOn = val;
  },
  SET_LOSS_TYPE(state, val) {
    state.lossTypeSelection = val;
  },
  ADD_SELECTED_LOSS_STOCK(state, val) {
    state.selectedLossStocks.unshift(val);
  },
  CLEAR_SELECTED_LOSS_STOCKS(state) {
    state.selectedLossStocks = [];
  },
  REMOVE_SELECTED_LOSS_STOCK(state, stockId) {
    let stockIndex = state.selectedLossStocks.findIndex((x) => x.id == stockId);
    state.selectedLossStocks.splice(stockIndex, 1);
  },
  SET_CAKE_QUESTIONED(state, bool) {
    state.isCakeQuestioned = bool;
    if (!bool) {
      state.hasNeedNavigationByQuestion = false;
    }
  },
  SET_CURRENT_CART_CUSTOMER(state, customer) {
    let currentCart = state.carts.find((x) => x.active);
    if (customer == null) {
      delete currentCart.customer;
    } else {
      currentCart.customer = {};
      Object.assign(currentCart.customer, customer);
    }
  },
  SET_NAVIGATION_QUESTION(state, question) {
    Object.assign(state.navigationQuestion, question);
  },
  HAS_NEED_NAVIGATION_BY_QUESTION(state, payload) {
    state.hasNeedNavigationByQuestion = payload;
  },
  SET_CURRENT_CART_NAVIGATED_BY_QUESTION(state) {
    let currentCart = state.carts.find((x) => x.active);
    currentCart.isNavigatedByQuestion = true;
  },
  SET_IS_TABLE_MOVE(state, isTableMove) {
    state.isTableMove = isTableMove;
  },
  SET_IS_TABLE_MERGE(state, isTableMerge) {
    state.isTableMerge = isTableMerge;
  },
  UPDATE_AREA(state, data) {
    const areas = state.areas;
    areas[data.index] = { ...areas[data.index], ...data.value };
    state.areas = [...areas];
  },
  SET_PRINTER_SETTINGS(state, printerSettings) {
    state.printerSettings = printerSettings;
  },
  SET_SELECTED_POS(state, posId) {
    state.selectedPosId = posId;
  },

  UPDATE_CARTS_BY_ID(state, cartArray) {
    if (!cartArray) return;

    cartArray.forEach(newCart => {
      if (!newCart || Object.keys(newCart).length === 0) return;

      const existingCartIndex = state.carts.findIndex(cart => cart && cart.id === newCart.id);
      if (existingCartIndex !== -1) {
        const currentCart = state.carts[existingCartIndex];
        
        // FIX [v22]: Frontend 'active' durumu icin tek kaynaktir.
        // Eger sepet yerelde aktifse aktif kalsin, degilse sunucudan 'active: true' gelse bile zorla kapat.
        // Bu sayede polling islemi kullanicinin o anki masasini degistiremez.
        if (currentCart && currentCart.active === true) {
          newCart.active = true;
        } else {
          newCart.active = false;
        }

        if (currentCart && currentCart.realId && !newCart.realId) {
          newCart.realId = currentCart.realId;
        }
        
        // [v29] BranchTableUId alanını koru (UUID Tabanlı Seans Yönetimi)
        if (currentCart && currentCart.branchTableUId && !newCart.branchTableUId) {
          newCart.branchTableUId = currentCart.branchTableUId;
          console.log(`[UUID Protection v29] Protected local UUID ${currentCart.branchTableUId} for table ${newCart.tableId}`);
        }

        // [v29] RowVersion Koruma: Sunucudan null gelirse hafızadaki son geçerli versiyonu kaybetme
        if (currentCart && currentCart.rowVersion && !newCart.rowVersion) {
            newCart.rowVersion = currentCart.rowVersion;
            console.log(`[RowVersion Protection v29] Protected local RowVersion for table ${newCart.tableId}`);
        }

        state.carts[existingCartIndex] = newCart;
      }
    });

    // Reaktiviteyi tetiklemek için state'i yeniden atıyoruz
    state.carts = [...state.carts];
  },

  SET_KUVER_SETTINGS(state, settings) {
    state.kuverSettings = settings;
  },
  CLEAR_ALL_CARTS(state) {
    state.carts = [
      {
        id: Date.now(),
        cartEntries: [],
        totalPrice: 0,
        active: true,
      },
    ];
  },
  SET_DISCOUNT_REASONS(state, discountReasons) {
    state.discountReasons = discountReasons;
  },
  DEACTIVATE_ALL_CARTS(state) {
    if (state.carts) {
      state.carts.forEach((x) => {
        if (x) x.active = false;
      });
    }
  },
  SET_IS_ACTIVE_TABLES_FILTER(state, payload) {
    state.isActiveTablesFilter = payload;
  }
};
